import { render, staticRenderFns } from "./RecentContentContainer.vue?vue&type=template&id=951be5a8&scoped=true&"
import script from "./RecentContentContainer.vue?vue&type=script&lang=js&"
export * from "./RecentContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./RecentContentContainer.vue?vue&type=style&index=0&id=951be5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951be5a8",
  null
  
)

export default component.exports